module.exports = __webpack_public_path__ + "static/reviewer_6-72888832a39590ad55e4afa7660ff498.png";